import { MimeTypes } from 'types';

export const getExtension = (mimeType: MimeTypes) => {
  if (mimeType === MimeTypes.jpeg) return 'jpeg';
  if (mimeType === MimeTypes.png) return 'png';
};
